var _defs, _polygon, _polyline, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonsDouble4Full(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "DOUBLE-_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 2760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #000;\n        stroke-width: 4px;\n      }\n\n      .st2 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient9);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st6 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st7 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient31);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient30);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient38);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient32);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient90);\n      }\n\n      .st16 {\n        fill: url(#linear-gradient91);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient61);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient60);\n      }\n\n      .st19 {\n        fill: url(#linear-gradient62);\n      }\n\n      .st20 {\n        fill: url(#linear-gradient69);\n      }\n\n      .st21 {\n        fill: url(#linear-gradient65);\n      }\n\n      .st22 {\n        fill: url(#linear-gradient68);\n      }\n\n      .st23 {\n        fill: url(#linear-gradient67);\n      }\n\n      .st24 {\n        fill: url(#linear-gradient64);\n      }\n\n      .st25 {\n        fill: url(#linear-gradient63);\n      }\n\n      .st26 {\n        fill: url(#linear-gradient66);\n      }\n\n      .st27 {\n        fill: url(#linear-gradient71);\n      }\n\n      .st28 {\n        fill: url(#linear-gradient70);\n      }\n\n      .st29 {\n        fill: url(#linear-gradient39);\n      }\n\n      .st30 {\n        fill: url(#linear-gradient34);\n      }\n\n      .st31 {\n        fill: url(#linear-gradient37);\n      }\n\n      .st32 {\n        fill: url(#linear-gradient35);\n      }\n\n      .st33 {\n        fill: url(#linear-gradient33);\n      }\n\n      .st34 {\n        fill: url(#linear-gradient36);\n      }\n\n      .st35 {\n        fill: url(#linear-gradient80);\n      }\n\n      .st36 {\n        fill: url(#linear-gradient81);\n      }\n\n      .st37 {\n        fill: url(#linear-gradient40);\n      }\n\n      .st38 {\n        fill: url(#linear-gradient41);\n      }\n\n      .st39 {\n        fill: url(#linear-gradient42);\n      }\n\n      .st40 {\n        fill: url(#linear-gradient46);\n      }\n\n      .st41 {\n        fill: url(#linear-gradient48);\n      }\n\n      .st42 {\n        fill: url(#linear-gradient43);\n      }\n\n      .st43 {\n        fill: url(#linear-gradient44);\n      }\n\n      .st44 {\n        fill: url(#linear-gradient47);\n      }\n\n      .st45 {\n        fill: url(#linear-gradient45);\n      }\n\n      .st46 {\n        fill: url(#linear-gradient49);\n      }\n\n      .st47 {\n        fill: url(#linear-gradient97);\n      }\n\n      .st48 {\n        fill: url(#linear-gradient98);\n      }\n\n      .st49 {\n        fill: url(#linear-gradient95);\n      }\n\n      .st50 {\n        fill: url(#linear-gradient99);\n      }\n\n      .st51 {\n        fill: url(#linear-gradient93);\n      }\n\n      .st52 {\n        fill: url(#linear-gradient96);\n      }\n\n      .st53 {\n        fill: url(#linear-gradient94);\n      }\n\n      .st54 {\n        fill: url(#linear-gradient92);\n      }\n\n      .st55 {\n        fill: url(#linear-gradient89);\n      }\n\n      .st56 {\n        fill: url(#linear-gradient88);\n      }\n\n      .st57 {\n        fill: url(#linear-gradient83);\n      }\n\n      .st58 {\n        fill: url(#linear-gradient85);\n      }\n\n      .st59 {\n        fill: url(#linear-gradient79);\n      }\n\n      .st60 {\n        fill: url(#linear-gradient87);\n      }\n\n      .st61 {\n        fill: url(#linear-gradient78);\n      }\n\n      .st62 {\n        fill: url(#linear-gradient77);\n      }\n\n      .st63 {\n        fill: url(#linear-gradient76);\n      }\n\n      .st64 {\n        fill: url(#linear-gradient84);\n      }\n\n      .st65 {\n        fill: url(#linear-gradient82);\n      }\n\n      .st66 {\n        fill: url(#linear-gradient86);\n      }\n\n      .st67 {\n        fill: url(#linear-gradient75);\n      }\n\n      .st68 {\n        fill: url(#linear-gradient73);\n      }\n\n      .st69 {\n        fill: url(#linear-gradient74);\n      }\n\n      .st70 {\n        fill: url(#linear-gradient72);\n      }\n\n      .st71 {\n        fill: url(#linear-gradient50);\n      }\n\n      .st72 {\n        fill: url(#linear-gradient51);\n      }\n\n      .st73 {\n        fill: url(#linear-gradient52);\n      }\n\n      .st74 {\n        fill: url(#linear-gradient59);\n      }\n\n      .st75 {\n        fill: url(#linear-gradient53);\n      }\n\n      .st76 {\n        fill: url(#linear-gradient56);\n      }\n\n      .st77 {\n        fill: url(#linear-gradient54);\n      }\n\n      .st78 {\n        fill: url(#linear-gradient57);\n      }\n\n      .st79 {\n        fill: url(#linear-gradient55);\n      }\n\n      .st80 {\n        fill: url(#linear-gradient58);\n      }\n\n      .st81 {\n        fill: url(#linear-gradient28);\n      }\n\n      .st82 {\n        fill: url(#linear-gradient29);\n      }\n\n      .st83 {\n        fill: url(#linear-gradient18);\n      }\n\n      .st84 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st85 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st86 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st87 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st88 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st89 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st90 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st91 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st92 {\n        fill: url(#linear-gradient19);\n      }\n\n      .st93 {\n        fill: url(#linear-gradient23);\n      }\n\n      .st94 {\n        fill: url(#linear-gradient22);\n      }\n\n      .st95 {\n        fill: url(#linear-gradient24);\n      }\n\n      .st96 {\n        fill: url(#linear-gradient25);\n      }\n\n      .st97 {\n        fill: url(#linear-gradient21);\n      }\n\n      .st98 {\n        fill: url(#linear-gradient20);\n      }\n\n      .st99 {\n        fill: url(#linear-gradient27);\n      }\n\n      .st100 {\n        fill: url(#linear-gradient26);\n      }\n\n      .st101 {\n        ", "\n      }\n\n       .rosette_color_1 {\n        fill: #521579;\n      }\n\n      .st102 {\n        fill: url(#linear-gradient);\n      }\n\n      .st103 {\n        ", "\n      }\n  .rosette_color_2 {\n        fill: #3db2a7;\n      }\n\n      .st104 {\n        fill: #fff;\n      }\n\n      .st105 {\n        fill: url(#linear-gradient100);\n      }\n\n      .st106 {\n        fill: url(#linear-gradient103);\n      }\n\n      .st107 {\n        fill: url(#linear-gradient102);\n      }\n\n      .st108 {\n        fill: url(#linear-gradient101);\n      }\n\n      .st109 {\n        display: none;\n      }\n\n      .st1 {\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 759.1,
    y1: 712.4,
    x2: 805.8,
    y2: 712.4,
    gradientTransform: "translate(461 -295.8) rotate(30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#818181"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 4888,
    y1: -2161.1,
    x2: 4934.7,
    y2: -2161.1,
    gradientTransform: "translate(-1577.2 103.8) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 700.2,
    y1: -168.6,
    x2: 746.9,
    y2: -168.6,
    gradientTransform: "translate(135.7 463) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 5049.1,
    y1: -3211.3,
    x2: 5095.8,
    y2: -3211.3,
    gradientTransform: "translate(-1808.2 907.8) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 509.2,
    y1: -917.8,
    x2: 555.9,
    y2: -917.8,
    gradientTransform: "translate(-5.1 1188.7) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 4851.5,
    y1: -4112,
    x2: 4898.2,
    y2: -4112,
    gradientTransform: "translate(-1859.5 1779) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: -16.8,
    y1: -1891.1,
    x2: 29.9,
    y2: -1891.1,
    gradientTransform: "translate(35.9 2298.5) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 4266.3,
    y1: -4820,
    x2: 4313,
    y2: -4820,
    gradientTransform: "translate(-1719.9 2694.8) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: -500.7,
    y1: -2479.8,
    x2: -454,
    y2: -2479.8,
    gradientTransform: "translate(232.1 3062.4) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 3313,
    y1: -5278.8,
    x2: 3359.7,
    y2: -5278.8,
    gradientTransform: "translate(-1385.7 3594) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: -1221.7,
    y1: -3041.4,
    x2: -1175,
    y2: -3041.4,
    gradientTransform: "translate(639.6 3941.5) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 1335.8,
    y1: -5404.6,
    x2: 1382.5,
    y2: -5404.6,
    gradientTransform: "translate(-589.8 4736.3) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: -2457.4,
    y1: -3514.7,
    x2: -2410.7,
    y2: -3514.7,
    gradientTransform: "translate(1522.8 5022.6) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: -153.6,
    y1: -5209.4,
    x2: -106.9,
    y2: -5209.4,
    gradientTransform: "translate(83 5363) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: -3297.1,
    y1: -3628.4,
    x2: -3250.4,
    y2: -3628.4,
    gradientTransform: "translate(2238.3 5596.2) rotate(30)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: -2548.1,
    y1: -4458.6,
    x2: -2502,
    y2: -4458.6,
    gradientTransform: "translate(-3625.6 2479.4) rotate(123.4) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: -4051.8,
    y1: -3533.7,
    x2: -4005.7,
    y2: -3533.7,
    gradientTransform: "translate(-2855.7 4381) rotate(97.9) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: -5826.8,
    y1: -2807.9,
    x2: -5780.7,
    y2: -2807.9,
    gradientTransform: "translate(-4174.6 2198.3) rotate(145.8) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient18",
    x1: -5129.1,
    y1: -3206.6,
    x2: -5083,
    y2: -3206.6,
    gradientTransform: "translate(-3831 4337.9) rotate(114.2) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient19",
    x1: -5689.8,
    y1: -2889.1,
    x2: -5643.7,
    y2: -2889.1,
    gradientTransform: "translate(-4174.6 2198.3) rotate(145.8) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient20",
    x1: -6055,
    y1: -2577.2,
    x2: -6008.9,
    y2: -2577.2,
    gradientTransform: "translate(-4743.2 4024.4) rotate(130.4) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient21",
    x1: -7004.3,
    y1: -1979.3,
    x2: -6958.2,
    y2: -1979.3,
    gradientTransform: "translate(-4371.4 2005.5) rotate(156.1) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient22",
    x1: -6503.8,
    y1: -2052.3,
    x2: -6457.8,
    y2: -2052.3,
    gradientTransform: "translate(-5256.1 3701.1) rotate(140.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient23",
    x1: -8696.6,
    y1: -537.7,
    x2: -8650.5,
    y2: -537.7,
    gradientTransform: "translate(-4577 1687.4) rotate(170.6) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient24",
    x1: -6983.5,
    y1: -1155.5,
    x2: -6937.4,
    y2: -1155.5,
    gradientTransform: "translate(-5858.9 3106.9) rotate(155.2) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient25",
    x1: -9773.3,
    y1: 654.1,
    x2: -9727.2,
    y2: 654.1,
    gradientTransform: "translate(-4687.8 1417.3) rotate(-177.9) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient26",
    x1: -7189.6,
    y1: -364.3,
    x2: -7143.5,
    y2: -364.3,
    gradientTransform: "translate(-6226.8 2553) rotate(166.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient27",
    x1: -10761.9,
    y1: 2143.4,
    x2: -10715.8,
    y2: 2143.4,
    gradientTransform: "translate(-4743.9 1036.8) rotate(-163.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient28",
    x1: -7231.8,
    y1: 696.4,
    x2: -7185.7,
    y2: 696.4,
    gradientTransform: "translate(-6520.9 1744.1) rotate(-178.6) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient29",
    x1: -11298.8,
    y1: 3813.5,
    x2: -11252.7,
    y2: 3813.5,
    gradientTransform: "translate(-4679.3 594.2) rotate(-145.4) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient30",
    x1: -6943.7,
    y1: 1971.7,
    x2: -6897.6,
    y2: 1971.7,
    gradientTransform: "translate(-6587.3 726.3) rotate(-160.8) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient31",
    x1: -14330.2,
    y1: 6498.9,
    x2: -14289.4,
    y2: 6498.9,
    gradientTransform: "translate(-4233.8 301.7) rotate(-125.7) scale(.6) skewX(49.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient32",
    x1: -6555.3,
    y1: 2696.6,
    x2: -6514,
    y2: 2696.6,
    gradientTransform: "translate(-6456.6 101.7) rotate(-149.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient33",
    x1: -12350.9,
    y1: 7024.4,
    x2: -12310.1,
    y2: 7024.4,
    gradientTransform: "translate(-4012.1 24.1) rotate(-108.7) scale(.6 .6) skewX(47.6)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient34",
    x1: -5614.3,
    y1: 3792,
    x2: -5573.1,
    y2: 3792,
    gradientTransform: "translate(-5958.3 -886.2) rotate(-130.3) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient35",
    x1: -10794.9,
    y1: 7134.1,
    x2: -10749.9,
    y2: 7134.1,
    gradientTransform: "translate(-3949.5 35.6) rotate(-106.1) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient36",
    x1: -5063,
    y1: 4146.7,
    x2: -5017.6,
    y2: 4146.7,
    gradientTransform: "translate(-5638 -1256.8) rotate(-121.6) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient37",
    x1: -8201.5,
    y1: 7379,
    x2: -8156.5,
    y2: 7379,
    gradientTransform: "translate(-3548.7 -142.2) rotate(-85.2) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient38",
    x1: -3688.6,
    y1: 4684.7,
    x2: -3643.2,
    y2: 4684.7,
    gradientTransform: "translate(-4666 -1951.3) rotate(-100.8) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient39",
    x1: -6837.9,
    y1: 7170.3,
    x2: -6792.8,
    y2: 7170.3,
    gradientTransform: "translate(-3382.2 -153.8) rotate(-77) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient40",
    x1: -3069,
    y1: 4733.7,
    x2: -3023.6,
    y2: 4733.7,
    gradientTransform: "translate(-4229.2 -2104.2) rotate(-92.5) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient41",
    x1: -4924.8,
    y1: 6690.2,
    x2: -4879.8,
    y2: 6690.2,
    gradientTransform: "translate(-3160.2 -139.8) rotate(-65.8) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient42",
    x1: -2257.8,
    y1: 4672.6,
    x2: -2212.3,
    y2: 4672.6,
    gradientTransform: "translate(-3611.8 -2217.6) rotate(-81.3) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient43",
    x1: -1312.3,
    y1: 5216.9,
    x2: -1267.2,
    y2: 5216.9,
    gradientTransform: "translate(-2810.2 -117.5) rotate(-49.4) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient44",
    x1: -1188.1,
    y1: 4328.8,
    x2: -1142.6,
    y2: 4328.8,
    gradientTransform: "translate(-2727.3 -2164.9) rotate(-65.4) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient45",
    x1: 1485.8,
    y1: 3559,
    x2: 1530.9,
    y2: 3559,
    gradientTransform: "translate(-2490.9 119.3) rotate(-30.5) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient46",
    x1: -118.2,
    y1: 3558.3,
    x2: -72.7,
    y2: 3558.3,
    gradientTransform: "translate(-1748.9 -1790.7) rotate(-46.5) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient47",
    x1: 3401.3,
    y1: 2016.2,
    x2: 3446.4,
    y2: 2016.2,
    gradientTransform: "translate(-2329 366.5) rotate(-16.1) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient48",
    x1: 515.1,
    y1: 2735.6,
    x2: 560.6,
    y2: 2735.6,
    gradientTransform: "translate(-1135.1 -1298.8) rotate(-32.1) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient49",
    x1: 4446,
    y1: 969.3,
    x2: 4491,
    y2: 969.3,
    gradientTransform: "translate(-2258.8 523.8) rotate(-7) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient50",
    x1: 810.6,
    y1: 2138.2,
    x2: 856,
    y2: 2138.2,
    gradientTransform: "translate(-817.3 -932.4) rotate(-23) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient51",
    x1: 6534.7,
    y1: -1224.8,
    x2: 6579.7,
    y2: -1224.8,
    gradientTransform: "translate(-2283.9 886.3) rotate(11.1) scale(.5 .6) skewX(40.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient52",
    x1: 759.8,
    y1: 712.2,
    x2: 806.5,
    y2: 712.2,
    gradientTransform: "translate(461 -296.1) rotate(30)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5a65d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8e6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ffff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5812e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient53",
    x1: 4889.4,
    y1: -2161.8,
    x2: 4936.1,
    y2: -2161.8,
    gradientTransform: "translate(-1577.2 103.5) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient54",
    x1: 700.8,
    y1: -168.9,
    x2: 747.5,
    y2: -168.9,
    gradientTransform: "translate(135.7 462.8) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient55",
    x1: 5050.5,
    y1: -3212.1,
    x2: 5097.2,
    y2: -3212.1,
    gradientTransform: "translate(-1808.2 907.6) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient56",
    x1: 509.8,
    y1: -918.2,
    x2: 556.5,
    y2: -918.2,
    gradientTransform: "translate(-5.1 1188.6) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient57",
    x1: 4852.8,
    y1: -4112.9,
    x2: 4899.4,
    y2: -4112.9,
    gradientTransform: "translate(-1859.5 1779) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient58",
    x1: -16.3,
    y1: -1891.6,
    x2: 30.4,
    y2: -1891.6,
    gradientTransform: "translate(35.9 2298.6) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient59",
    x1: 4267.4,
    y1: -4821,
    x2: 4314.1,
    y2: -4821,
    gradientTransform: "translate(-1719.9 2695) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient60",
    x1: -500.3,
    y1: -2480.4,
    x2: -453.7,
    y2: -2480.4,
    gradientTransform: "translate(232.2 3062.6) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient61",
    x1: 3313.8,
    y1: -5279.8,
    x2: 3360.5,
    y2: -5279.8,
    gradientTransform: "translate(-1385.5 3594.3) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient62",
    x1: -1221.5,
    y1: -3042.1,
    x2: -1174.8,
    y2: -3042.1,
    gradientTransform: "translate(639.8 3941.9) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient63",
    x1: 1336.3,
    y1: -5405.6,
    x2: 1383,
    y2: -5405.6,
    gradientTransform: "translate(-589.5 4736.7) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient64",
    x1: -2457.4,
    y1: -3515.4,
    x2: -2410.7,
    y2: -3515.4,
    gradientTransform: "translate(1523.1 5023) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient65",
    x1: -153.4,
    y1: -5210.2,
    x2: -106.8,
    y2: -5210.2,
    gradientTransform: "translate(83.4 5363.5) rotate(52.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient66",
    x1: -3297.2,
    y1: -3629,
    x2: -3250.5,
    y2: -3629,
    gradientTransform: "translate(2238.8 5596.7) rotate(30)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient67",
    x1: -2548.3,
    y1: -4459.3,
    x2: -2502.2,
    y2: -4459.3,
    gradientTransform: "translate(-3625.6 2479.4) rotate(123.4) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient68",
    x1: -4052.1,
    y1: -3534.4,
    x2: -4006,
    y2: -3534.4,
    gradientTransform: "translate(-2855.7 4381) rotate(97.9) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient69",
    x1: -5827.5,
    y1: -2808.3,
    x2: -5781.4,
    y2: -2808.3,
    gradientTransform: "translate(-4174.6 2198.3) rotate(145.8) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient70",
    x1: -5129.5,
    y1: -3207.1,
    x2: -5083.5,
    y2: -3207.1,
    gradientTransform: "translate(-3831 4337.9) rotate(114.2) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient71",
    x1: -5690.5,
    y1: -2889.4,
    x2: -5644.5,
    y2: -2889.4,
    gradientTransform: "translate(-4174.6 2198.3) rotate(145.8) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient72",
    x1: -6055.6,
    y1: -2577.6,
    x2: -6009.5,
    y2: -2577.6,
    gradientTransform: "translate(-4743.2 4024.4) rotate(130.4) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient73",
    x1: -7005.3,
    y1: -1979.5,
    x2: -6959.2,
    y2: -1979.5,
    gradientTransform: "translate(-4371.4 2005.5) rotate(156.1) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient74",
    x1: -6504.5,
    y1: -2052.6,
    x2: -6458.4,
    y2: -2052.6,
    gradientTransform: "translate(-5256.1 3701.1) rotate(140.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient75",
    x1: -8697.8,
    y1: -537.6,
    x2: -8651.7,
    y2: -537.6,
    gradientTransform: "translate(-4577 1687.4) rotate(170.6) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient76",
    x1: -6984.1,
    y1: -1155.6,
    x2: -6938.1,
    y2: -1155.6,
    gradientTransform: "translate(-5858.9 3106.9) rotate(155.2) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient77",
    x1: -9774.6,
    y1: 654.4,
    x2: -9728.5,
    y2: 654.4,
    gradientTransform: "translate(-4687.8 1417.3) rotate(-177.9) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient78",
    x1: -7190.2,
    y1: -364.3,
    x2: -7144.2,
    y2: -364.3,
    gradientTransform: "translate(-6226.8 2553) rotate(166.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient79",
    x1: -10763.3,
    y1: 2143.9,
    x2: -10717.2,
    y2: 2143.9,
    gradientTransform: "translate(-4743.9 1036.8) rotate(-163.2) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient80",
    x1: -7232.4,
    y1: 696.6,
    x2: -7186.4,
    y2: 696.6,
    gradientTransform: "translate(-6520.9 1744.1) rotate(-178.6) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient81",
    x1: -11300.1,
    y1: 3814.2,
    x2: -11254,
    y2: 3814.2,
    gradientTransform: "translate(-4679.3 594.2) rotate(-145.4) scale(.6 .7) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient82",
    x1: -6944.2,
    y1: 1972,
    x2: -6898.2,
    y2: 1972,
    gradientTransform: "translate(-6587.3 726.3) rotate(-160.8) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient83",
    x1: -14332.1,
    y1: 6500,
    x2: -14291.3,
    y2: 6500,
    gradientTransform: "translate(-4233.8 301.7) rotate(-125.7) scale(.6) skewX(49.8)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient84",
    x1: -6555.7,
    y1: 2697,
    x2: -6514.5,
    y2: 2697,
    gradientTransform: "translate(-6456.6 101.7) rotate(-149.7) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient85",
    x1: -12352.3,
    y1: 7025.6,
    x2: -12311.5,
    y2: 7025.6,
    gradientTransform: "translate(-4012.1 24.1) rotate(-108.7) scale(.6 .6) skewX(47.6)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient86",
    x1: -5614.6,
    y1: 3792.6,
    x2: -5573.3,
    y2: 3792.6,
    gradientTransform: "translate(-5958.3 -886.2) rotate(-130.3) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient87",
    x1: -10796,
    y1: 7135.3,
    x2: -10751,
    y2: 7135.3,
    gradientTransform: "translate(-3949.5 35.6) rotate(-106.1) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient88",
    x1: -5063.2,
    y1: 4147.4,
    x2: -5017.8,
    y2: 4147.4,
    gradientTransform: "translate(-5638 -1256.8) rotate(-121.6) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient89",
    x1: -8202.1,
    y1: 7380.1,
    x2: -8157.1,
    y2: 7380.1,
    gradientTransform: "translate(-3548.7 -142.2) rotate(-85.2) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient90",
    x1: -3688.5,
    y1: 4685.4,
    x2: -3643.1,
    y2: 4685.4,
    gradientTransform: "translate(-4666 -1951.3) rotate(-100.8) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient91",
    x1: -6838.2,
    y1: 7171.4,
    x2: -6793.2,
    y2: 7171.4,
    gradientTransform: "translate(-3382.2 -153.8) rotate(-77) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient92",
    x1: -3068.9,
    y1: 4734.4,
    x2: -3023.5,
    y2: 4734.4,
    gradientTransform: "translate(-4229.2 -2104.2) rotate(-92.5) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient93",
    x1: -4924.8,
    y1: 6691.1,
    x2: -4879.8,
    y2: 6691.1,
    gradientTransform: "translate(-3160.2 -139.8) rotate(-65.8) scale(.5 .6) skewX(41)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient94",
    x1: -2257.5,
    y1: 4673.2,
    x2: -2212,
    y2: 4673.2,
    gradientTransform: "translate(-3611.8 -2217.6) rotate(-81.3) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient95",
    x1: -1311.7,
    y1: 5217.5,
    x2: -1266.7,
    y2: 5217.5,
    gradientTransform: "translate(-2810.2 -117.5) rotate(-49.4) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient96",
    x1: -1187.6,
    y1: 4329.3,
    x2: -1142.2,
    y2: 4329.3,
    gradientTransform: "translate(-2727.3 -2164.9) rotate(-65.4) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient97",
    x1: 1486.8,
    y1: 3559.3,
    x2: 1531.9,
    y2: 3559.3,
    gradientTransform: "translate(-2490.9 119.3) rotate(-30.5) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient98",
    x1: -117.6,
    y1: 3558.7,
    x2: -72.2,
    y2: 3558.7,
    gradientTransform: "translate(-1748.9 -1790.7) rotate(-46.5) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient99",
    x1: 3402.5,
    y1: 2016.3,
    x2: 3447.6,
    y2: 2016.3,
    gradientTransform: "translate(-2329 366.5) rotate(-16.1) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient100",
    x1: 515.8,
    y1: 2735.9,
    x2: 561.2,
    y2: 2735.9,
    gradientTransform: "translate(-1135.1 -1298.8) rotate(-32.1) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient101",
    x1: 4447.3,
    y1: 969.2,
    x2: 4492.3,
    y2: 969.2,
    gradientTransform: "translate(-2258.8 523.8) rotate(-7) scale(.6 .6) skewX(36.2)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient102",
    x1: 811.3,
    y1: 2138.4,
    x2: 856.7,
    y2: 2138.4,
    gradientTransform: "translate(-817.3 -932.4) rotate(-23) scale(1 1) skewX(-2.7)",
    xlinkHref: "#linear-gradient52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient103",
    x1: 6536.3,
    y1: -1225.3,
    x2: 6581.3,
    y2: -1225.3,
    gradientTransform: "translate(-2283.9 886.3) rotate(11.1) scale(.5 .6) skewX(40.8)",
    xlinkHref: "#linear-gradient52"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st101 rosette_color_1",
    points: "1142.2 1200.4 1144 1198.8 1140.2 1191.3 1139.4 1187.5 1155.9 1169.2 1176.4 1185 1202.6 1144.9 1195 1137.8 1206.9 1116.8 1226.4 1122 1244.1 1077.7 1234.1 1073.4 1239.8 1048.1 1263.2 1051.5 1270.8 1005.7 1260.3 1002.4 1262.7 976.2 1277 975.2 1273.6 929 1262.7 926.6 1262.7 903.7 1274.6 897.5 1259.8 852.7 1250.3 854.1 1240.3 831.7 1253.1 825 1230.3 784 1221.2 786.9 1204 766.4 1209.3 760.2 1175.9 727.8 1166.9 733 1146.8 717.8 1158.8 698.7 1116.8 674.9 1109.7 682 1088.2 672 1091.5 659.2 1048.6 644.4 1042.9 652.5 1014.8 647.2 1014.8 637.7 970.9 631.5 967.1 640.6 939 642.5 937.6 627.2 892.3 633.4 889.4 644.4 864.6 650.6 862.7 642.5 817.9 659.2 820.3 669.2 796.5 682 791.2 674.4 751.2 698.2 755.5 709.2 738.8 728.7 733.5 724.9 701.6 756.9 709.2 768.8 694.9 785 687.8 783.6 665.4 822.2 672 829.8 664.9 855.1 655.8 853.6 644.4 898.9 652.5 903.2 648.7 929 638.7 928.5 642 975.7 651.1 977.1 652.5 1004.8 646.8 1009 663 1051 672 1052 683 1072 675.4 1077.7 698.3 1117.3 708.3 1116.3 722.6 1136.3 714.9 1143 744.5 1178.3 751.2 1174.5 770.2 1189.7 766.9 1195.9 775.9 1201.5 487.6 2506.5 626.3 2418 714.8 2556.7 838.6 1991 836.5 2613.2 952.3 2500.3 1070.6 2611.2 1070.2 1987.2 1191.3 2548.8 1280.9 2410.8 1418.8 2500.3 1142.2 1200.4"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st103 rosette_color_2",
    points: "1070.2 1247 1070.6 2613.6 953.5 2498.3 836.8 2615 838.2 1239.6 868.9 1250.9 873.5 1252.3 877.2 1255.1 877.7 2436.2 953.5 2360.9 1030.2 2436.6 1029.7 1251.6 1038.3 1265.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st102",
    x: 758.6,
    y: 707,
    width: 47.7,
    height: 10.8,
    transform: "translate(-251.4 486.7) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    x: 802.5,
    y: 682.4,
    width: 21.4,
    height: 10.8,
    transform: "translate(-207.8 384.4) rotate(-23.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 822.7,
    y: 673.4,
    width: 47.7,
    height: 10.8,
    transform: "translate(-170.1 299.5) rotate(-18.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 869.4,
    y: 657.5,
    width: 21.4,
    height: 10.8,
    transform: "translate(-118.1 196.4) rotate(-11.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st10",
    x: 891.1,
    y: 654.8,
    width: 47.7,
    height: 10.8,
    transform: "translate(-82.3 132.5) rotate(-7.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st9",
    x: 943.1,
    y: 649.9,
    width: 21.4,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    x: 963.3,
    y: 658.7,
    width: 47.7,
    height: 10.8,
    transform: "translate(89.5 -116.7) rotate(7.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 1014.3,
    y: 660,
    width: 21.4,
    height: 10.8,
    transform: "translate(166.3 -204.1) rotate(12.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st7",
    x: 1034.8,
    y: 670.8,
    width: 47.7,
    height: 10.8,
    transform: "translate(251.5 -286.4) rotate(17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 1081.3,
    y: 685.1,
    width: 21.4,
    height: 10.8,
    transform: "translate(392.5 -395.7) rotate(24.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st89",
    x: 1098.7,
    y: 703,
    width: 47.7,
    height: 10.8,
    transform: "translate(504.5 -466.3) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st88",
    x: 1138,
    y: 729.9,
    width: 21.4,
    height: 10.8,
    transform: "translate(808.9 -585.6) rotate(42.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st85",
    x: 1148.4,
    y: 756.3,
    width: 47.7,
    height: 10.8,
    transform: "translate(954.7 -619.2) rotate(48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st84",
    x: 1189,
    y: 781,
    width: 21.4,
    height: 10.8,
    transform: "translate(1146.8 -647.1) rotate(54.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st91",
    x: 1193.5,
    y: 811.7,
    width: 47.7,
    height: 10.8,
    transform: "translate(1309.2 -646.2) rotate(59.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "1229.9 859.9 1222.9 839.9 1233.2 836.5 1240.3 856.5 1229.9 859.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "1248.5 905.4 1230.4 858.9 1240.6 855.1 1258.7 901.7 1248.5 905.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "1245.7 928.7 1246.9 907.6 1257.7 908.4 1256.6 929.5 1245.7 928.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st83",
    points: "1248.1 978.4 1243.9 928.7 1254.7 927.9 1259 977.7 1248.1 978.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "1242.9 1000 1244.1 978.9 1254.9 979.7 1253.8 1000.8 1242.9 1000"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "1233.4 1046.8 1243.2 997.9 1253.8 1000.2 1244 1049.2 1233.4 1046.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "1217.9 1066.7 1222.8 1046.1 1233.3 1048.8 1228.4 1069.5 1217.9 1066.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "1200.1 1111.1 1218.5 1064.7 1228.5 1068.9 1210.2 1115.3 1200.1 1111.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "1181.9 1127.9 1191.8 1109.2 1201.4 1114.4 1191.4 1133.2 1181.9 1127.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "1153.6 1166.4 1183 1126.1 1191.7 1132.6 1162.3 1172.9 1153.6 1166.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "1128.2 1174.2 1141.7 1157.8 1149.9 1164.9 1136.5 1181.3 1128.2 1174.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st100",
    points: "1094.1 1209.8 1130.9 1176.1 1138.1 1184.3 1101.3 1217.9 1094.1 1209.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "1068.1 1215.6 1085.3 1203.2 1091.5 1212.1 1074.3 1224.5 1068.1 1215.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "1023.5 1232.8 1067.7 1209.7 1072.6 1219.4 1028.4 1242.6 1023.5 1232.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "1000.9 1236.9 1021 1230.3 1024.2 1240.7 1004.1 1247.3 1000.9 1236.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "953.1 1239.7 1002.3 1231.1 1004 1241.9 954.8 1250.5 953.1 1239.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "944.2 1241.9 957.5 1239.8 958.6 1250.7 945.3 1252.7 944.2 1241.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "900.3 1235.4 944.2 1236.4 943.9 1247.3 900 1246.3 900.3 1235.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st33",
    points: "886.3 1229.2 900.8 1232 898.2 1242.6 883.6 1239.7 886.3 1229.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "847 1208.5 888.1 1224.1 884.1 1234.2 843.1 1218.6 847 1208.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st32",
    points: "826.7 1198.6 843.2 1204.5 839.2 1213.8 822.7 1207.9 826.7 1198.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st34",
    points: "785.5 1170.7 828.1 1194.3 822 1204.6 779.4 1181 785.5 1170.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st31",
    points: "771.7 1159.5 785 1170.9 777.9 1178.1 764.6 1166.7 771.7 1159.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "744 1120.6 775.4 1157.9 766.1 1165.3 734.7 1128.1 744 1120.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "728.5 1107 740.1 1120.2 732.1 1126.4 720.5 1113.2 728.5 1107"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "706.7 1064.6 732.5 1105.9 722.2 1112 696.4 1070.7 706.7 1064.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "693.7 1047.5 702.4 1062.7 693.3 1067.1 684.6 1051.9 693.7 1047.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st39",
    points: "680.5 1001.6 697.7 1047.2 686.4 1051.1 669.2 1005.6 680.5 1001.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st42",
    points: "673.6 980.4 676.9 999.9 666.9 1001 663.5 981.5 673.6 980.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st43",
    points: "672.7 932.4 676.8 981 664.9 981.7 660.8 933.1 672.7 932.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "676.3 912.7 673.2 932.3 663.3 930.1 666.5 910.5 676.3 912.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st40",
    points: "691.1 867.1 679.2 914.3 667.7 911.1 679.6 863.9 691.1 867.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "691.8 844.3 683.9 862.5 674.9 857.9 682.8 839.7 691.8 844.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st41",
    points: "717.4 803.8 694.2 846.6 683.8 840.6 707.1 797.8 717.4 803.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "722.4 782.8 711.7 799.6 703.5 793.6 714.2 776.9 722.4 782.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "754.1 746.9 724.4 785.5 715.1 777.9 744.8 739.3 754.1 746.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "764.2 730.8 751.3 742.7 744.9 734.9 759.4 722.1 764.2 730.8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st109"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st73",
    x: 759.3,
    y: 706.8,
    width: 47.7,
    height: 10.8,
    transform: "translate(-251.2 487) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st75",
    x: 803.2,
    y: 682.3,
    width: 21.4,
    height: 10.8,
    transform: "translate(-207.6 384.7) rotate(-23.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st77",
    x: 823.4,
    y: 673.2,
    width: 47.7,
    height: 10.8,
    transform: "translate(-170 299.7) rotate(-18.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st79",
    x: 870,
    y: 657.3,
    width: 21.4,
    height: 10.8,
    transform: "translate(-118 196.5) rotate(-11.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st76",
    x: 891.8,
    y: 654.7,
    width: 47.7,
    height: 10.8,
    transform: "translate(-82.3 132.6) rotate(-7.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st78",
    x: 943.8,
    y: 649.7,
    width: 21.4,
    height: 10.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st80",
    x: 964,
    y: 658.5,
    width: 47.7,
    height: 10.8,
    transform: "translate(89.5 -116.8) rotate(7.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st74",
    x: 1014.9,
    y: 659.8,
    width: 21.4,
    height: 10.8,
    transform: "translate(166.3 -204.3) rotate(12.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st18",
    x: 1035.5,
    y: 670.6,
    width: 47.7,
    height: 10.8,
    transform: "translate(251.5 -286.6) rotate(17.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 1082,
    y: 685,
    width: 21.4,
    height: 10.8,
    transform: "translate(392.5 -396.1) rotate(24.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st19",
    x: 1099.4,
    y: 702.8,
    width: 47.7,
    height: 10.8,
    transform: "translate(504.6 -466.7) rotate(30)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 1138.7,
    y: 729.7,
    width: 21.4,
    height: 10.8,
    transform: "translate(809 -586.1) rotate(42.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 1149.1,
    y: 756.2,
    width: 47.7,
    height: 10.8,
    transform: "translate(954.8 -619.8) rotate(48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 1189.7,
    y: 780.9,
    width: 21.4,
    height: 10.8,
    transform: "translate(1146.9 -647.7) rotate(54.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    x: 1194.2,
    y: 811.5,
    width: 47.7,
    height: 10.8,
    transform: "translate(1309.4 -646.9) rotate(59.7)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "1230.6 859.7 1223.6 839.7 1233.9 836.3 1240.9 856.3 1230.6 859.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "1249.1 905.3 1231.1 858.7 1241.3 855 1259.4 901.5 1249.1 905.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "1246.4 928.6 1247.5 907.4 1258.4 908.2 1257.2 929.4 1246.4 928.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "1248.8 978.2 1244.6 928.5 1255.4 927.8 1259.7 977.5 1248.8 978.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "1243.6 999.9 1244.8 978.7 1255.6 979.5 1254.5 1000.7 1243.6 999.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "1234 1046.7 1243.9 997.7 1254.5 1000 1244.7 1049 1234 1046.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "1218.6 1066.6 1223.5 1046 1234 1048.7 1229.1 1069.3 1218.6 1066.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "1200.8 1110.9 1219.2 1064.5 1229.2 1068.7 1210.9 1115.1 1200.8 1110.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st67",
    points: "1182.6 1127.7 1192.5 1109 1202.1 1114.3 1192.1 1133 1182.6 1127.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "1154.3 1166.2 1183.7 1125.9 1192.4 1132.5 1163 1172.8 1154.3 1166.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "1128.9 1174 1142.3 1157.7 1150.6 1164.7 1137.2 1181.1 1128.9 1174"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st61",
    points: "1094.7 1209.6 1131.6 1175.9 1138.8 1184.1 1102 1217.8 1094.7 1209.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "1068.8 1215.4 1086 1203 1092.2 1211.9 1075 1224.4 1068.8 1215.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "1024.1 1232.7 1068.4 1209.5 1073.3 1219.2 1029 1242.4 1024.1 1232.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "1001.6 1236.7 1021.7 1230.1 1024.9 1240.5 1004.7 1247.1 1001.6 1236.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "953.8 1239.5 1003 1231 1004.7 1241.7 955.5 1250.3 953.8 1239.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "944.9 1241.7 958.2 1239.7 959.2 1250.5 945.9 1252.5 944.9 1241.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "901 1235.3 944.9 1236.3 944.6 1247.2 900.7 1246.1 901 1235.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "887 1229 901.5 1231.9 898.9 1242.4 884.3 1239.6 887 1229"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "847.7 1208.3 888.8 1223.9 884.8 1234.1 843.8 1218.5 847.7 1208.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "827.4 1198.4 843.9 1204.4 839.9 1213.7 823.4 1207.7 827.4 1198.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "786.2 1170.6 828.7 1194.1 822.7 1204.5 780.1 1180.9 786.2 1170.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "772.4 1159.3 785.7 1170.7 778.6 1178 765.3 1166.6 772.4 1159.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "744.7 1120.5 776.1 1157.7 766.8 1165.2 735.4 1127.9 744.7 1120.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "729.2 1106.9 740.8 1120.1 732.7 1126.2 721.2 1113 729.2 1106.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "707.4 1064.5 733.2 1105.8 722.9 1111.8 697.1 1070.5 707.4 1064.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "694.4 1047.3 703.1 1062.5 694 1067 685.3 1051.8 694.4 1047.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "681.2 1001.5 698.4 1047 687.1 1051 669.9 1005.4 681.2 1001.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "674.2 980.2 677.6 999.8 667.6 1000.9 664.2 981.3 674.2 980.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st52",
    points: "673.4 932.3 677.5 980.8 665.6 981.5 661.5 933 673.4 932.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "677 912.6 673.9 932.2 664 929.9 667.2 910.3 677 912.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "691.8 866.9 679.9 914.2 668.4 911 680.3 863.7 691.8 866.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st50",
    points: "692.5 844.2 684.6 862.4 675.6 857.8 683.5 839.6 692.5 844.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st105",
    points: "718.1 803.7 694.9 846.4 684.5 840.5 707.8 797.7 718.1 803.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st108",
    points: "723.1 782.7 712.4 799.4 704.2 793.4 714.9 776.7 723.1 782.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st107",
    points: "754.8 746.7 725.1 785.3 715.8 777.8 745.5 739.2 754.8 746.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "764.9 730.6 752 742.6 745.6 734.8 760.1 721.9 764.9 730.6"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st104",
    cx: 962.2,
    cy: 949.6,
    r: 150
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.2,1056.6c-31.7-31.5-47.9-77.4-43.2-121.8,6.8-76.4,73.5-137,150.2-136.4,107.5-.2,181.2,109.9,140,209.2-41.2,99.4-171,125.2-247,49h0ZM857.1,1054.7c74.6,74.7,202,49.3,242.3-48.3,31.5-74.7-5.1-163.7-80.3-194.3-91.9-38.3-195.6,23.7-205.2,122.8-4.4,43.8,11.9,88.9,43.2,119.7h0Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "",
    cx: 962.4,
    cy: 949.8,
    r: 131.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1197.1 980.3 1278.7 977.8 1275 930.9 1198.8 920 1264.5 902.8 1264.4 929.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1178.3 1037.2 1264.5 1053.8 1271.4 1007.3 1194.6 980.3 1262.8 977.7 1262.2 1003.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1152.2 1092.6 1227.4 1124.6 1243.9 1080.5 1179.8 1039.6 1241.6 1049.8 1235.7 1074.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1111.6 1136 1177.8 1186.7 1203.7 1147.4 1151.9 1092.6 1208.4 1117 1197 1140"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1059.4 1168.1 1110.1 1232.7 1144.3 1200.4 1112.7 1135.6 1155.8 1171.8 1139.5 1191.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1003.3 1188.6 1038.3 1266.7 1078.8 1242.8 1059.8 1169.2 1096.4 1217.5 1076.1 1233.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "951.1 1193.9 960 1274.9 1004.6 1267.4 1002.9 1190.7 1027 1246.4 1003.9 1257.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "860.7 1166.3 832.1 1238.2 876.4 1254 903.1 1188.6 898 1251.6 882 1245.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "808.1 1136 767 1196 806.8 1221.2 856.8 1170.2 837.3 1225.3 814.1 1214.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "766.1 1095.7 714.7 1145.3 746 1180.4 807.8 1135.3 768.8 1190 753.1 1176.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "736.5 1046.7 675.5 1080.1 698.9 1120.9 767.5 1092.9 722.3 1137.4 708.5 1118.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "720.2 987.7 647.7 1009.8 662.9 1054.3 735.8 1044.6 684.1 1076.6 672.8 1053.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "716 936.6 641.2 930.2 642.4 977.7 719.1 987.3 654 1006.1 651.9 980.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "724.8 876.9 657.6 855.1 644.6 900.3 714.6 935.9 649.3 930.7 653.3 905.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "748.1 821.5 689.5 784.2 665.6 824.8 726.9 875.5 665.5 857.7 672.7 831.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "780.9 775.6 735.6 726 702.5 759.4 749.2 820.8 694.9 786.7 709.7 771.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "831.1 737.5 791.5 675.9 751.8 701 782.3 776.7 740.4 729.5 754.8 710.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "886.5 716 863.5 644.7 819.3 661 830.7 736.5 797.6 682.8 820.4 671"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "946.1 705.7 938.8 629.6 892.2 635.7 886.8 714.9 866.1 652 891 645.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1007.5 711 1017.4 638.9 970.6 634.1 948.2 708.6 941.5 644 967.1 643.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1068.2 731.2 1092.7 660.5 1048.1 645.3 1008.2 712.8 1017.5 648.5 1042.7 653.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1117.3 764.3 1158.3 700.7 1117.9 676.6 1067.9 731.5 1087.3 673.3 1110.8 683.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1159.3 811.3 1210 762.1 1176 729.5 1117.6 765 1146.9 719.4 1167.5 734.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1181.2 860 1254.2 826 1230.6 785.3 1159.3 812.7 1205.4 767.6 1221 788.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1197.1 917.9 1275.6 899.9 1261.4 855 1178 862.5 1240.7 832.3 1251.4 855.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "904.1 1190.3 898 1268.8 942.5 1270 951.1 1194.9 956 1264.6 942.9 1264.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1032.8,1112.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "1070.4 1247.4 1070.4 1986.2 1190.3 2549.5 1279.9 2411.5 1417.9 2501.1 1141.4 1204.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M887.1,1124.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "774.6 1201.5 486.4 2506.7 625.1 2418.3 713.6 2556.9 837.8 1994.5 837.8 1240.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "837.8 1994.5 837.8 2614.2 954.1 2497.9 1070.4 2614.2 1070.4 1986.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "878.4 1250.2 877.7 1814.1 877.7 2436.3 953.6 2360.4 1029.5 2436.3 1029.5 1793.9 1030.2 1251.2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1109.7,982.6c14-2.2,28.1-3.2,42.3-3.9,14.2-.6,28.3-.7,42.4,1.4,0,0-.5,1.1-.5,1-10.9-15.5-6.8-32.8-3.7-50.1,1-4,1.9-14,7-14.5,1.6-.1,3.1.9,3.9,2.1,2.1,3.1,2.6,6.7,3.3,10.2,1.6,10,1.8,20.2,0,30.3-1,5.6-1.9,11.3-3.8,16.8-.7,1.6-1.1,3-2.6,4.3-.5.4-1.4.7-2.2.4-.7-.3-1.1-.7-1.4-1-.3-.3-.4-.6-.7-.9-1-1.4-1.9-2.9-2.9-4.4l1-.8c1.4,1.4,2.8,2.9,4.2,4.4h.1c.2.3.3.3.3.3,0,0-.3,0-.2,0,1.2-2,1.5-4.8,1.9-7.1,1.5-10.9,3-21.9,1.9-33-.4-5.1-.8-10.8-2.8-15.5,0,0-.2-.3-.2-.3,0,0-.1-.1-.1-.2,0-.1-.2-.3-.2-.3,0,0,.2.2.7.1.4,0,.7-.3.7-.2-1.9,3-2.4,6.9-3.3,10.5-1.2,5.4-2.3,11-3.4,16.5-2.4,10.6-1.7,22.2,3.5,31.9,0,0,.8.8.8.8-7.4,1.7-14.9,2.6-22.4,3.2-14.1,1.1-28.2,1.1-42.4.8-7.1-.2-14.1-.5-21.2-1.3v-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.1,1025.7c14.2.8,28.2,2.9,42.1,5.3,14,2.5,27.8,5.3,41.2,10.4,0,0-.7,1-.7.9-7.4-17.4.2-33.6,6.8-49.8,1.8-3.7,4.7-13.2,9.9-12.6,1.6.2,2.8,1.5,3.4,2.9,1.4,3.5,1.2,7.1,1.1,10.7-.6,10.1-2.4,20.2-6.3,29.6-2.2,5.3-4.2,10.6-7.2,15.6-1,1.5-1.7,2.7-3.5,3.7-.6.3-1.5.3-2.2,0-.6-.4-.9-.9-1.1-1.3-.2-.3-.3-.7-.4-1.1-.7-1.6-1.3-3.3-1.9-4.9l1.2-.6c1.1,1.7,2.2,3.4,3.2,5.2,0,0,.1.1.1.1.1.2.3.3.3.2,0,0-.3,0-.2-.1,1.5-1.7,2.4-4.4,3.3-6.5,3.7-10.4,7.4-20.8,8.7-31.8.6-5.1,1.5-10.7.5-15.7,0,0,0-.4,0-.4,0,0,0-.1-.1-.2,0-.1-.1-.3-.1-.3,0,0,.2.2.7.3.4,0,.8-.1.7,0-2.4,2.5-3.8,6.3-5.4,9.5-2.3,5.1-4.5,10.2-6.8,15.4-4.5,9.8-6.2,21.4-3.2,31.9,0,0,.6.9.6.9-7.6.1-15.1-.7-22.6-1.6-14-1.9-27.8-5-41.6-8.3-6.9-1.7-13.7-3.6-20.5-5.8l.2-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.7,1060.7c13.5,4.5,26.5,10.2,39.4,16.1,12.9,6,25.5,12.4,37.1,20.9,0,0-.9.7-.9.7-2.8-18.8,8.7-32.4,19.2-46.3,2.9-3.4,10.2-14.8,14.8-7.7,1.6,4,0,8.5-1.1,12.3-4.7,15.2-13.5,28.8-24.5,40.1-2.4,2.5-6.9,4.7-7.3-.7-.2-1.7-.4-3.5-.6-5.3l1.3-.3c.6,1.9,1.2,3.9,1.8,5.8,0,0,0,.2,0,.2,0,.3.2.3.2.3,0-.1-.2-.2-.2-.2,1.9-1.2,3.4-3.6,4.9-5.4,6.2-9,12.4-18.1,16.5-28.5,1.9-4.8,4.1-9.9,4.4-15.1,0,0,0-.4,0-.4,0-.1,0-.1,0-.2,0-.1,0-.3,0-.3,0,0,.1.2.6.5.4.2.8,0,.7,0-3,1.8-5.3,5.1-7.7,7.8-3.5,4.3-7,8.7-10.4,13.1-6.9,8.3-11.5,19-11.2,30,0,0,.4,1.1.4,1.1-7.4-1.9-14.5-4.6-21.4-7.5-13-5.5-25.6-12.1-38.1-18.9-6.2-3.5-12.3-7-18.3-11l.6-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.4,1086.2c11.8,8,22.8,17,33.6,26.3,10.8,9.3,21.3,18.9,30.2,30.2,0,0-1.1.4-1.1.4,2.3-18.9,17-28.8,30.8-39.4,3.7-2.5,13.8-11.4,16.2-3.4.5,4.3-2.3,8.1-4.3,11.6-8.5,13.4-20.7,24-34.3,31.9-3,1.7-7.9,2.7-6.9-2.7.2-1.7.5-3.5.8-5.2h1.3c0,2.1.1,4.2.2,6.2v.2c0,.3.1.4.1.3,0-.1-.2-.2-.1-.2,2.2-.6,4.3-2.5,6.1-3.9,8.4-7,16.8-14,23.5-22.9,3.1-4.1,6.6-8.5,8.3-13.3,0,0,.1-.4.1-.4,0-.1,0-.2,0-.2,0-.1,0-.3,0-.3,0,0,0,.3.4.6.3.3.7.3.6.3-3.4.9-6.4,3.4-9.5,5.4-4.5,3.2-9,6.5-13.5,9.8-8.8,6.1-16.1,15.2-18.7,25.8,0,0,0,1.1,0,1.1-6.6-3.8-12.7-8.4-18.6-13.1-11.1-8.9-21.5-18.6-31.6-28.6-5-5-10-10.1-14.7-15.6l.9-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.2,1099.4c9.1,11.1,17.1,22.9,24.9,34.9,7.8,12.1,15.1,24.3,20.6,37.7,0,0-1.2.1-1.1,0,7.5-17.4,24.3-22.8,40.5-28.9,3.9-1.1,12.7-5.5,15.9-1.3.9,1.3.8,3.2.2,4.5-.1.4-.4,1-.7,1.3-3.4,5.1-8.3,8.5-13,12.1-6.9,5-14.7,8.9-22.7,11.7-4.7,1.7-9.4,3.6-14.5,4-3.1.3-5.4-1.4-3.6-4.8.7-1.6,1.5-3.2,2.2-4.8l1.2.5c-.4,1.4-.7,2.7-1.1,4.1,0,.2-.4,1.3-.4,1.5,0,0,0,.3,0,.3v.2c-.1.3,0,.4,0,.4,0-.1-.1-.3,0-.2,2.3,0,4.8-1.2,7-2,5-2.1,10.1-4.5,15.1-6.8,4.7-2.4,9.4-5.3,13.8-8.4,4.2-3.1,8.9-6.3,11.8-10.7,0,0,0-.1,0-.2,0-.1.1-.3.1-.3,0,0,0,.3.2.7.2.4.6.5.5.4-3.5-.1-7.1,1.4-10.6,2.5-5.2,1.7-10.5,3.6-15.7,5.5-10.2,3.3-19.6,9.9-25.2,19.4,0,0-.2,1.1-.2,1.1-5.3-5.6-9.8-11.7-14.2-17.9-8.2-11.7-15.4-24-22.4-36.5-3.4-6.3-6.8-12.6-9.8-19.2l1.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.3,1108.8c6.6,12.8,12,26,17.2,39.4,5.1,13.4,9.8,27,12.3,41.2,0,0-1.2-.1-1.1-.2,10.9-15.4,28.5-17.1,45.6-19.6,4.1-.3,13.6-2.7,15.8,2.1.6,1.5.1,3.3-.7,4.4-2.2,3-5.4,4.7-8.4,6.5-8.8,4.7-18.3,8.3-28.2,9.7-5.6.8-11.2,1.8-16.9,1.7-1.8-.1-3.1,0-4.9-1.1-.5-.4-1.1-1.1-1.1-2,0-.7.3-1.3.5-1.6.2-.4.5-.6.7-.9,1-1.4,2.1-2.8,3.2-4.2l1.1.7c-.9,1.8-1.8,3.6-2.7,5.4,0,0,0,.2,0,.2-.1.2,0,.4,0,.4,0-.1,0-.3,0-.2,2.2.5,4.9-.1,7.2-.5,10.7-2.1,21.4-4.2,31.4-8.7,4.6-2.1,9.8-4.2,13.5-7.6,0,0,.3-.3.3-.3,0,0,0-.1.1-.2,0-.1.2-.2.2-.2,0,0,0,.3,0,.7.2.4.5.6.4.6-3.4-.9-7.3-.1-10.9.1-5.5.6-11,1.3-16.5,2-10.7,1.1-21.3,5.5-28.6,13.6,0,0-.4,1-.5,1-4-6.6-7.2-13.5-10.2-20.5-5.5-13.2-10.1-26.8-14.3-40.5-2.1-6.9-4-13.8-5.6-20.8l1.2-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.7,1102.9c3.1,14.1,5,28.3,6.6,42.6,1.5,14.3,2.6,28.6,1.4,43,0,0-1.1-.4-1.1-.5,14.5-12,31.8-9,49-7,4,.8,13.8,1,14.7,6.2.2,1.6-.7,3.2-1.8,4.1-2.9,2.4-6.4,3.1-9.8,4-9.7,2.2-19.8,3.2-29.7,2-5.6-.7-11.2-1.2-16.7-2.8-1.7-.6-3-.9-4.4-2.4-.4-.5-.7-1.4-.5-2.2.2-.7.6-1.2.9-1.5.3-.3.6-.5.9-.7,1.4-1.1,2.8-2.2,4.2-3.2,0,0,.9,1,.9,1-1.3,1.5-2.7,3-4,4.5,0,0-.1.1-.1.1-.2.2-.2.4-.2.3,0,0,0-.3,0-.2,2,1.1,4.8,1.2,7.1,1.4,10.8.8,21.7,1.6,32.6-.2,5-.8,10.5-1.5,15-3.8,0,0,.3-.2.3-.2,0,0,.1-.1.2-.2.1,0,.3-.2.2-.2,0,0-.1.2,0,.7,0,.4.3.7.3.7-3-1.7-7-2-10.5-2.7-5.4-.9-10.9-1.6-16.4-2.4-10.6-1.7-21.9-.2-31.1,5.6,0,0-.7.9-.7.9-2.2-7.4-3.5-15-4.7-22.5-2-14.2-2.9-28.5-3.5-42.8-.2-7.2-.4-14.4-.1-21.6h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.1,1086.6c-1.3,14.4-3.8,28.5-6.6,42.6-2.9,14.1-6.2,28-11.6,41.4,0,0-.9-.8-.9-.8,17.4-7,33,1.3,48.8,8.5,3.5,2,12.9,5.2,12.1,10.4-.2,1.6-1.6,2.8-3,3.3-3.5,1.4-7,1-10.5.8-9.9-.9-19.8-3.1-28.9-7.4-5.1-2.4-10.3-4.7-15.1-7.8-1.4-1.1-2.6-1.8-3.5-3.6-.2-.6-.3-1.5.2-2.2.4-.6.9-.9,1.3-1.1.4-.2.7-.3,1-.4,1.6-.6,3.3-1.2,4.9-1.8l.6,1.2c-1.7,1-3.5,2.1-5.2,3.1h-.1c-.2.2-.3.4-.2.4,0,0,0-.3.1-.2,1.6,1.6,4.2,2.6,6.3,3.6,10.1,4.1,20.2,8.2,31.1,9.9,5,.8,10.5,1.8,15.4,1,0,0,.4,0,.4,0,0,0,.1,0,.2,0,.1,0,.3,0,.3-.1,0,0-.2.2-.3.7,0,.4.1.8,0,.7-2.4-2.6-6-4.1-9.2-5.8-4.9-2.5-9.9-4.9-14.9-7.4-9.5-4.9-20.8-7-31.3-4.3,0,0-.9.6-.9.6.1-7.7,1.2-15.3,2.3-22.9,2.4-14.1,5.8-28.1,9.5-41.9,1.9-6.9,3.9-13.8,6.4-20.6l1.3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.3,807.1c-8.8-11.3-16.5-23.4-23.9-35.6-7.4-12.3-14.4-24.7-19.5-38.3,0,0,1.2,0,1.2,0-8,17.2-24.9,22-41.3,27.7-3.9,1-12.9,5.1-15.9.8-.9-1.3-.7-3.2,0-4.5.1-.4.5-.9.7-1.3,3.6-5,8.5-8.3,13.4-11.7,7-4.7,14.9-8.5,23.1-11,4.7-1.5,9.5-3.3,14.6-3.6,3.1-.2,5.4,1.6,3.4,4.9-.8,1.6-1.6,3.2-2.4,4.7l-1.2-.5c.4-1.4.8-2.7,1.2-4.1,0-.2.4-1.3.5-1.5,0,0,0-.3,0-.3v-.2c.1-.3,0-.4,0-.4,0,.1.1.3,0,.2-2.3,0-4.8,1-7,1.8-5.1,1.9-10.2,4.2-15.2,6.3-4.8,2.2-9.6,5-14.1,8-4.3,3-9.1,6.1-12.1,10.3,0,0,0,.1,0,.2,0,.1-.2.3-.1.3,0,0,0-.3-.2-.7-.2-.4-.6-.5-.5-.5,3.5.2,7.2-1.2,10.7-2.2,5.3-1.6,10.6-3.3,15.9-5,10.3-3,19.9-9.3,25.7-18.6,0,0,.3-1.1.3-1.1,5.1,5.7,9.5,12,13.7,18.3,7.8,12,14.7,24.5,21.3,37.2,3.2,6.4,6.4,12.8,9.2,19.4l-1.1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.5,799c-6.2-13-11.2-26.4-16-39.9-4.7-13.6-9-27.2-11.1-41.6,0,0,1.2.2,1.1.2-11.4,15.1-29,16.2-46.1,18.3-4.1.2-13.7,2.3-15.7-2.6-.6-1.5,0-3.3.8-4.4,2.3-3,5.5-4.5,8.6-6.2,9-4.4,18.5-7.7,28.5-8.8,5.6-.7,11.2-1.4,16.9-1.2,1.8.2,3.1.2,4.8,1.3.5.4,1,1.2,1,2,0,.7-.3,1.3-.6,1.6-.2.4-.5.6-.7.9-1.1,1.4-2.2,2.8-3.3,4.1l-1.1-.7c.9-1.8,1.9-3.6,2.9-5.3,0,0,0-.2,0-.2.1-.2,0-.4,0-.4,0,.1,0,.3,0,.2-2.2-.6-4.9,0-7.2.2-10.7,1.8-21.5,3.5-31.6,7.8-4.7,1.9-9.9,3.9-13.7,7.2,0,0-.3.3-.3.3,0,0,0,.1-.1.2,0,.1-.2.2-.2.2,0,0,0-.3,0-.8-.1-.4-.5-.6-.4-.6,3.3,1,7.2.3,10.9.2,5.5-.4,11-1,16.5-1.5,10.7-.8,21.4-4.9,29-12.7,0,0,.5-1,.5-1,3.8,6.7,6.8,13.8,9.6,20.8,5.2,13.4,9.3,27.1,13.1,40.9,1.9,6.9,3.6,13.9,5,21l-1.2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.9,803.5c-2.7-14.1-4.2-28.4-5.3-42.7-1.1-14.4-1.8-28.7-.1-43.1,0,0,1.1.5,1,.5-14.8,11.6-32.1,8.1-49.2,5.6-3.9-.9-13.8-1.4-14.5-6.6-.2-1.6.8-3.2,1.9-4,3-2.3,6.5-2.9,9.9-3.7,9.8-1.9,19.8-2.6,29.8-1.1,5.6.8,11.2,1.6,16.6,3.3,1.6.7,3,1,4.4,2.5.4.5.7,1.4.5,2.2-.2.7-.6,1.1-1,1.4-.3.3-.6.5-.9.7-1.4,1.1-2.8,2.1-4.2,3.1,0,0-.9-1-.9-1,1.4-1.5,2.8-3,4.2-4.4,0,0,.1-.1.1-.1.2-.2.2-.3.2-.3,0,0,0,.3,0,.2-2-1.1-4.8-1.3-7.1-1.7-10.8-1.1-21.6-2.2-32.5-.8-5,.6-10.6,1.2-15.1,3.4,0,0-.3.2-.3.2,0,0-.1.1-.2.2-.1,0-.3.2-.2.2,0,0,.1-.2.1-.7,0-.4-.3-.7-.3-.7,3,1.8,6.9,2.2,10.5,3,5.4,1,10.9,1.9,16.4,2.9,10.5,2,21.9.9,31.2-4.7,0,0,.7-.9.7-.9,2,7.5,3.1,15.1,4,22.6,1.6,14.3,2.1,28.6,2.3,42.9,0,7.2,0,14.4-.5,21.6h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1035.9,816.8c.3-14.4,1.8-28.7,3.6-42.9,1.9-14.3,4.2-28.4,8.8-42.1,0,0,1,.7.9.7-16.9,8.2-33.1,1-49.3-5.1-3.7-1.7-13.2-4.3-12.8-9.6.1-1.6,1.4-2.9,2.7-3.5,3.4-1.6,6.9-1.5,10.5-1.5,10,.2,19.9,1.7,29.3,5.3,5.3,2,10.6,3.9,15.6,6.8,1.5,1,2.7,1.6,3.7,3.4.3.6.4,1.5,0,2.2-.4.6-.9,1-1.2,1.2-.3.2-.7.3-1,.5-1.6.7-3.2,1.4-4.8,2.1,0,0-.6-1.2-.6-1.2,1.6-1.2,3.3-2.3,5-3.4,0,0,.1-.1.1-.1.2-.1.2-.3.2-.3,0,0,0,.3-.1.2-1.7-1.5-4.4-2.3-6.6-3.1-10.3-3.4-20.7-6.8-31.7-7.7-5.1-.4-10.6-1.1-15.5,0,0,0-.4.1-.4.1,0,0-.1,0-.2.1-.1,0-.3.1-.3.1,0,0,.2-.2.3-.7,0-.4-.2-.8-.1-.7,2.5,2.4,6.3,3.6,9.6,5.2,5.1,2.1,10.2,4.2,15.4,6.3,9.9,4.2,21.2,5.6,31.5,2.1,0,0,.9-.7.9-.7.4,7.7-.1,15.4-.8,23-1.4,14.3-3.9,28.4-6.6,42.5-1.5,7-3,14-5,21l-1.3-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.9,838.9c4.7-13.6,10.6-26.6,16.7-39.6,6.2-12.9,12.8-25.6,21.4-37.2,0,0,.7,1,.7,1-18.6,2.4-31.7-9.5-45.2-20.5-3.3-3.1-14.3-10.7-7.2-15.1,4-1.5,8.3.3,12.1,1.4,14.9,5,28,14.4,38.9,25.8,2.4,2.5,4.5,7.1-.9,7.4-1.7.2-3.5.3-5.2.5,0,0-.2-1.3-.2-1.3,1.9-.6,3.9-1.1,5.8-1.7h.2c.3-.1.3-.3.3-.3-.1,0-.2.2-.2.2-1.2-2-3.4-3.6-5.3-5.1-8.8-6.5-17.6-13-27.7-17.4-4.7-2-9.7-4.4-14.7-4.8,0,0-.4,0-.4,0-.1,0-.1,0-.2,0-.1,0-.3,0-.3,0,0,0,.2-.1.5-.6.2-.4,0-.8.1-.7,1.7,3.1,4.9,5.5,7.5,8,4.1,3.7,8.4,7.3,12.7,10.9,8.1,7.2,18.5,12,29.3,12,0,0,1-.4,1.1-.4-2,7.5-4.9,14.6-7.8,21.6-5.7,13.1-12.5,25.7-19.4,38.2-3.6,6.2-7.2,12.4-11.2,18.3l-1.2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.4,872.3c7.4-12.3,15.9-23.8,24.6-35.1,8.8-11.3,17.8-22.3,28.6-31.8,0,0,.5,1.1.4,1.1-18.7-1.6-29-16.1-40-29.7-2.6-3.7-11.8-13.5-3.9-16.3,4.2-.7,8.1,2,11.6,3.9,13.5,8.1,24.4,20,32.7,33.5,1.8,3,3,7.9-2.4,7.1-1.7-.2-3.5-.4-5.2-.6,0,0,0-1.3,0-1.3,2-.1,4-.3,6-.4h.2c.3,0,.4-.2.3-.2-.1,0-.2.2-.2.1-.7-2.2-2.6-4.2-4.1-6.1-7.2-8.2-14.5-16.5-23.5-22.9-4.1-3-8.6-6.4-13.4-7.9,0,0-.4,0-.4,0-.1,0-.1,0-.2,0-.1,0-.3,0-.3,0,0,0,.3,0,.6-.5.3-.4.2-.7.2-.7,1,3.4,3.6,6.4,5.7,9.4,3.3,4.5,6.7,8.9,10.1,13.3,6.4,8.7,15.6,15.7,26.2,18,0,0,1.1-.1,1.1-.1-3.5,6.9-7.8,13.2-12.1,19.4-8.3,11.6-17.5,22.5-26.9,33.2-4.8,5.3-9.6,10.6-14.8,15.5l-1-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.4,907.3c11-9.2,22.6-17.2,34.5-25.1,11.9-7.8,24-15.2,37.2-20.6,0,0,.1,1.2,0,1.2-17.1-7.7-22.3-24.8-28.3-41.3-1.1-4-5.4-13-1.2-16.1,1.3-.9,3.1-.8,4.4-.2,3.4,1.6,5.6,4.4,8,7.1,6.3,7.8,11.7,16.5,15.1,26.1,1.9,5.4,4,10.7,5.1,16.4.2,1.8.6,3.1-.1,5.1-.2.6-.9,1.3-1.7,1.5-.7.1-1.3,0-1.7-.2-.4-.1-.7-.3-1-.5-1.6-.7-3.2-1.5-4.7-2.3l.5-1.2c1.9.5,3.9,1,5.8,1.6,0,0,.2,0,.2,0,.2,0,.4,0,.4,0-.1,0-.2.1-.2,0,0-2.3-1.1-4.9-1.9-7.1-4.2-10.2-8.4-20.4-14.8-29.4-3-4.2-6.1-8.9-10.1-11.9,0,0-.3-.2-.3-.2,0,0-.1,0-.2,0-.1,0-.3-.1-.3-.1,0,0,.3,0,.7-.2.4-.2.5-.6.4-.6-.1,3.5,1.4,7.2,2.4,10.8,1.7,5.3,3.5,10.6,5.3,16,3.2,10.4,9.7,20,19,25.6,0,0,1.1.2,1.1.2-5.5,5.3-11.6,9.9-17.7,14.4-11.6,8.2-23.8,15.5-36.1,22.5-6.2,3.4-12.5,6.8-18.9,9.8l-.7-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.4,951.9c12.6-6.6,25.7-12,38.9-17.2,13.3-5.1,26.6-9.8,40.7-12.2,0,0-.1,1.2-.2,1.2-15.1-11.2-16.6-29-19.1-46.4-.2-4.1-2.6-13.8,2.2-16,1.4-.6,3.2-.1,4.3.8.4.2.8.6,1.1.9,4.2,4.5,6.4,10,8.8,15.5,3.3,7.9,5.4,16.5,6.3,25,.6,5,1.4,10.1.8,15.2-.4,3.2-2.6,5.1-5.4,2.5-1.4-1.1-2.8-2.2-4.1-3.3l.7-1.1c1.2.6,2.5,1.3,3.7,1.9.2,0,1.2.6,1.4.7,0,0,.2.1.2.1h.2c.2.2.4.1.3.1-.1,0-.3,0-.2,0,.5-2.2,0-5-.4-7.3-.9-5.4-2.2-11-3.3-16.4-1.3-5.2-3-10.5-5.1-15.5-2.1-4.8-4.2-10.2-7.7-14,0,0-.1,0-.2-.1-.1,0-.2-.2-.2-.2,0,0,.3,0,.7,0,.4-.2.6-.5.5-.4-.9,3.4-.2,7.4,0,11,.5,5.5,1.2,11.1,1.9,16.7,1,10.8,5.3,21.6,13.2,29.1,0,0,1,.5,1,.5-6.5,4-13.4,7.2-20.3,10.3-13,5.6-26.4,10.1-39.9,14.3-6.8,2-13.6,4-20.5,5.6l-.4-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.9,1065.2c-3.3,13.3-7.8,26.3-12.5,39.1-4.9,12.8-10.1,25.4-17.4,37.1,0,0-.8-.9-.7-.9,17-3.4,30,7.8,42.7,17.4,3.3,2.9,13.4,9.3,7.5,14.1-.8.6-1.6.7-2.5.9-3.3.3-6.1-.6-9.1-1.4-10.2-3.1-19.7-8.2-27.9-15-2.5-2.2-16.5-12-9.7-14.9,2-.5,3.9-.7,5.9-1,0,0,.3,1.3.3,1.3-1.5.6-3,1.2-4.6,1.7-.3.1-.7.2-.8.3-.2,0-.2.2-.1.1,0-.1,0-.2.1-.1,1.2,1.8,3.3,3.2,5.1,4.5,4.1,2.9,8.6,5.7,12.8,8.5,4.2,2.5,8.8,4.8,13.4,6.7,4.4,1.7,9.3,3.9,14,3.9,0,0,.1,0,.2,0,0,0,.2,0,0,0,0,0-.4.3-.5.8,0,.4,0,.6,0,.6-1.7-2.8-4.6-4.9-7.2-7.2-3.9-3.3-8-6.5-12-9.8-7.6-6.5-17.4-10.8-27.4-10.2,0,0-1,.5-1,.5,1.2-7.3,3.3-14.4,5.6-21.3,4.3-13,9.7-25.5,15.3-38,2.9-6.2,5.9-12.4,9.2-18.4l1.2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.3,1029.5c-7.8,12.1-16.5,23.4-25.5,34.5-9.1,11.1-18.4,21.9-29.5,31.1,0,0-.4-1.1-.4-1.1,17.3,2,26.6,16.7,36.1,29.7,2.3,3.7,10.3,13,3.4,15.8-1,.3-1.7.2-2.6,0-3.3-.7-5.7-2.4-8.4-4.1-8.9-6.1-16.6-13.8-22.6-22.8-1.8-2.8-12.5-16.4-5.3-17.3,2.1.2,3.9.6,6,.9,0,0,0,1.3,0,1.3-1.6,0-3.3.2-4.9.2-.3,0-.7,0-.8,0-.2,0-.2.1,0,0,.1-.1.1-.2.1,0,.7,2.1,2.3,4.1,3.7,5.9,3.1,4,6.6,8.1,9.9,12,3.3,3.7,7.1,7.3,11,10.5,3.8,3,7.8,6.6,12.4,8,0,0,.1,0,.2,0,0,0,.2,0,0,0,0,0-.5.3-.8.7-.2.4-.1.5-.1.5-.8-3.3-3.1-6.2-4.9-9.2-2.9-4.3-5.9-8.7-8.8-13-5.5-8.5-13.6-15.7-23.5-18.2,0,0-1.1.1-1.1.1,3.7-6.8,8.1-13,12.7-19.1,8.6-11.4,18.1-22.1,27.8-32.5,4.9-5.2,9.9-10.3,15.2-15.2l1,.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.2,994.3c-10.8,9-22.4,16.9-34.1,24.6-11.8,7.6-23.7,14.9-36.8,20.1,0,0,0-1.2,0-1.2,15.8,7.5,20.6,24.5,26,39.9,1.1,4.2,6.2,15.8-1.3,16.3-1.1,0-1.7-.4-2.6-.8-2.9-1.8-4.7-4.2-6.8-6.6-5.8-7.6-10.7-16-13.7-25.1-.9-3.4-9.3-23.7-1.5-22.1,1.9.8,3.7,1.8,5.5,2.8,0,0-.5,1.2-.5,1.2-1.9-.5-3.7-1.1-5.6-1.6-.2,0-.2,0,0,0,.2,0,.2-.1.1,0,0,2.3,1.1,4.7,1.9,6.9,3.9,9.7,7.6,19.5,13.5,28.2,2.7,4,5.5,8.6,9.3,11.5.4.3.7.3.5.3-.3,0-.8.2-1,.4-.3.4-.3.5-.3.4.1-3.4-1.2-7-2.1-10.4-1.5-5.1-3.1-10.2-4.7-15.3-2.9-9.9-8.5-19.3-17.2-24.9,0,0-1.1-.2-1.1-.2,5.5-5.2,11.4-9.8,17.5-14.1,11.5-8.1,23.5-15.2,35.7-22,6.1-3.4,12.3-6.7,18.7-9.6l.7,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.2,949.3c-20.2,9.4-41.2,17.1-62.5,23.4-7.2,1.9-14.4,3.8-21.8,4.8l.2-1.2c13.9,10.8,15.4,28.5,17.6,44.8.4,3.4.9,7,.6,10.6-.2,1.6-.4,3.5-2.2,4.7-7.6,4.3-14.8-19.1-16.5-24.3-1.6-5.2-2.4-10.8-3-16.2-.5-4.1-.9-8.2-.9-12.4.1-1.6,0-3,.8-4.6.6-1.4,2.3-1.9,3.4-1.1.7.4,1.1.9,1.7,1.3,1,.8,2.1,1.7,3.1,2.6l-.7,1.1c-1.5-.8-4.2-2.4-5.1-2.8.2,0,.2-.1.2,0-.4,2.3.2,4.9.5,7.2.9,5.2,2,10.5,3,15.7,1.8,7.5,4.5,15.1,7.8,22.2,1.1,2.2,2.6,5.1,4.2,6.6-.3-.1-.8,0-1.1.2-.4.3-.4.5-.4.4,0-.1.2-.6.3-1.2.3-8.5-1.3-17.1-2-25.6-.9-10.3-4.6-20.8-11.9-28.2,0,0-1-.5-1-.5,7-3.9,14.3-7,21.6-9.9,13.8-5.4,28-9.7,42.3-13.7,7.2-1.9,14.4-3.8,21.7-5.2l.4,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.2,916.2c-13.6,2-27.2,2.7-40.8,3.1-13.7.3-27.3.2-40.9-2.2,0,0,.5-1.1.5-1,10,14.8,6.4,31.9,3.7,48.4-1,4-1.8,15.8-8,14.1-1.5-.5-2.7-2.2-3.1-3.2-1.3-2.9-1.8-5.6-2.3-8.6-1.7-11-1.6-22.2.6-33.1.9-4.8,1.7-9.7,3.6-14.2,1.1-2.8,3.8-4.4,5.6-1,0,0,.5.9.5.9.7,1.1,1.4,2.3,2.1,3.5l-1,.8c-.9-1-1.9-2-2.8-3-.3-.3-1-1.2-1.3-1.4-.2-.1-.3-.1-.1,0,.2,0,.4,0,.3,0-1.9,4.6-1.8,10-2.5,15-.9,7.7-1.4,16.1-.7,23.8.5,5.1.6,11.1,3,15.6-.2-.1-.6-.3-1-.2-.6.1-.7.3-.7.3,1.7-3,2.2-6.8,3-10.3,1.1-5.2,2.1-10.6,3.1-15.9,2.1-10.2,1.6-21.4-3.2-30.8,0,0-.8-.8-.8-.8,7.2-1.6,14.5-2.3,21.7-2.8,13.6-.8,27.2-.6,40.9,0,6.8.4,13.6.8,20.4,1.7v1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.2,874.4c-20.7-1.7-41.3-5.2-61.5-10.2-6.7-1.8-13.4-3.7-19.9-6.4l.7-.9c6.9,16.6.1,32.4-5.8,48.1-1.7,3.6-4.2,13.1-9.2,12.5-7.8-1.2-3.3-24.1-2.3-29.7,1-5.4,3-10.7,5-15.8,1.5-3.8,3.1-7.7,5.1-11.3.9-1.4,1.5-2.6,3.1-3.7,1.3-.8,2.9,0,3.4,1.2.3.7.5,1.4.8,2,.5,1.3.9,2.6,1.4,3.8l-1.2.6c-.9-1.4-1.8-2.9-2.6-4.4-.2-.3-.4-.7-.5-.8-.1-.2-.3-.3-.2-.2,0,0,.2,0,.3,0-1.1,1.6-2.2,4.3-2.9,6.5-1.5,4.3-3.4,10.8-4.8,15.3-2,7.5-3.2,15.5-3.7,23.3,0,2.6-.3,5.8.6,8.1,0,0-.2-.3-.8-.4-.4,0-.7,0-.9.2,2.2-2.5,3.5-6.2,5-9.4,2.1-4.9,4.1-9.9,6.1-14.9,4.1-9.6,5.6-20.6,2.9-30.8,0,0-.6-.9-.6-.9,7.5,0,14.9.8,22.1,1.9,13.7,2.1,27.2,5.3,40.6,8.7,6.7,1.8,13.4,3.7,20,6l-.3,1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.3,845c-19.6-8.2-38.3-18.2-56.4-29.3-5.9-3.9-11.8-7.8-17.3-12.5l1-.7c2.7,17.8-7.5,31.1-17.1,44.8-2.5,3-7.5,11.8-12.2,9.5-5.5-3.3.3-16.8,1.9-21.5,4.4-11.6,11.4-21.9,19.6-31.1,3.2-3.3,6.9-4.4,7.1,1.7.2,1.3.3,2.7.4,4l-1.3.3c-.4-1.3-.8-2.6-1.2-3.9l-.6-1.9c0-.2-.2-.4-.2-.3,0,0,.3.2.3.2-1.7,1.2-3.1,3.5-4.3,5.3-2.5,3.8-5.9,9.6-8.3,13.5-2.5,4.5-4.7,9.3-6.6,14.2-1.7,4.8-4.2,10.5-3.9,15.4-.2-.4-1.1-.8-1.5-.6,0,0,.4-.2.8-.5,6-5.8,10.6-13.3,15.7-19.9,6.3-8.2,10.3-18.5,10.1-28.9,0,0-.4-1.1-.4-1.1,7.3,2.4,14.1,5.6,20.9,8.9,12.6,6.4,24.7,13.7,36.6,21.3,5.9,3.9,11.8,7.8,17.5,12.1l-.6,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.4,828.8c-17.5-14.9-33.7-31.3-48.8-48.6-4.9-5.9-9.8-11.8-14.1-18.4l1.1-.4c-2,17.9-15.1,27.7-28,38.2-2.7,2.1-5.4,4.3-8.6,5.9-.9.5-2.8,1.1-4.3.5-8.5-3.9,7.7-23.1,11.2-27.3,3.5-4.1,7.7-7.6,11.9-11,3.2-2.5,6.4-5,9.9-7,2.4-1.4,6.8-2.7,6.6,1.7,0,0-.3,2-.3,2-.2,1.3-.4,2.6-.7,4h-1.3c0-1.4-.1-2.8-.1-4.1v-2c0-.2-.1-.4-.2-.4,0,0,.2.3.2.3-1.8.7-3.8,2.4-5.5,3.8-3.4,2.9-8.2,7.5-11.5,10.6-3.5,3.6-6.9,7.6-10,11.7-2.9,4.1-6.7,8.9-7.7,13.7,0,0,0-.1-.3-.5-.2-.2-.7-.5-.9-.5-.1,0,.4,0,.8-.3,7.3-3.9,13.6-9.7,20.3-14.6,8.2-6,14.6-14.9,17.1-24.9,0,0-.1-1.3-.1-1.3l1.3.9c18.3,14.1,33.5,31.5,48.5,48.9,4.9,5.9,9.8,11.8,14.4,18.1l-.9.9h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonsDouble4Full);
export default __webpack_public_path__ + "static/media/Ribbons_Double4_FULL.50f2f42fa7502b887c002d875e1159f8.svg";
export { ForwardRef as ReactComponent };